import { __assign } from "tslib";
import React from 'react';
import StarFilled from 'wix-ui-icons-common/StarFilled';
import s from './solution-info.scss';
import { composer } from '../../../../component-decorators/composer';
import { config } from '../../../../config';
import { HeaderContext } from '../../solution-page-views/solution-page-header/header-context';
import { biLogger } from '../../../../bi';
import { getBundleAppSavedPrice, isBundleAppAndInstalled, isBundleAppAndNotInstalled, } from '../../../../common/utils';
import { TeaserPreviewWrapper, DevelopedByWrapper, } from '../../preview-elements/';
import { AddToSite } from './add-to-site';
import { VisibilityDetector } from '../../../visibility-detector/visibility-detector';
import { SolutionBadge } from '@wix/app-market-collection-widget';
import { Heading, Text } from 'wix-style-react';
import { AppMarketLink } from '../../../app-market-link';
import { Origin, Path } from '../../../../enums/marketplace-enums';
import { isAppSetupIncomplete } from '../../../../common/is-app-setup-incomplete';
export var dtoToDetailsProps = function (_a) {
    var _b;
    var company = _a.company, baseInfo = _a.baseInfo;
    var id = baseInfo.id, name = baseInfo.name, teaser = baseInfo.teaser, icon = baseInfo.icon, numberOfReviews = baseInfo.numberOfReviews, reviewStars = baseInfo.reviewStars, openConsentIn = baseInfo.openConsentIn, Tags = baseInfo.Tags;
    return {
        companySlug: (_b = company === null || company === void 0 ? void 0 : company.companyBase) === null || _b === void 0 ? void 0 : _b.slug,
        companyId: company.companyBase.id,
        id: id,
        name: name,
        icon: icon,
        teaser: teaser,
        numberOfReviews: numberOfReviews,
        reviewStars: reviewStars,
        Tags: Tags,
        pricing: baseInfo.pricing,
        developerName: baseInfo.company ? baseInfo.company.name : 'Dev Name',
        openConsentIn: openConsentIn,
        isRequiredWixPremium: baseInfo.pricing && baseInfo.pricing.isRequiredWixPremium,
        biData: dtoBaseToDeatilsBiData(baseInfo),
    };
};
export var SolutionInfoDetails = composer()
    .withTranslation()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (props) {
    var _a;
    var isAppInstalled = !!(props.marketplaceStore.installedApps &&
        props.marketplaceStore.installedApps.findIndex(function (installedApp) { return installedApp.webSolutionBase.id === props.id; }) > -1);
    return (React.createElement("div", { "data-testid": "solution-info-details", className: s.infoDetailsContainer },
        React.createElement(Heading, { className: s.infoTitle, appearance: "H1", dataHook: "solution-name", property: "name" }, props.name),
        React.createElement("link", { property: "applicationCategory", href: "https://schema.org/BrowserApplication" }),
        React.createElement(Text, { dataHook: "solution-developer", size: "small" },
            props.t('solution.page.developerName.by'),
            React.createElement(DevelopedByWrapper, { name: props.developerName },
                React.createElement(Text, { size: "small", dataHook: "developer-name-solution-description", property: "brand" },
                    config.origin === Origin.STANDALONE && (React.createElement(AppMarketLink, { to: Path.DEVELOPER + "/" + props.companySlug, onClick: function () {
                            config.goto({
                                path: Path.DEVELOPER,
                                slug: props.companySlug,
                            });
                        } }, props.developerName)),
                    config.origin !== Origin.STANDALONE && (React.createElement("span", null, props.developerName))))),
        React.createElement("div", { className: s.infoDetailsTeaser },
            React.createElement(TeaserPreviewWrapper, { teaser: props.teaser },
                React.createElement(Text, { weight: "thin", size: "medium", dataHook: "solution-info-teaser" }, props.teaser))),
        React.createElement(RateAndReviewers, __assign({}, props)),
        React.createElement("div", { className: s.btnAndPricing },
            React.createElement(HeaderContext.Consumer, null, function (value) { return (React.createElement(VisibilityDetector, { onVisible: value.hideHeader, onUnVisible: value.showHeader },
                React.createElement(AddToSite, { addToSiteData: props, size: 'large', location: 'main_cta' }))); }),
            React.createElement("div", { className: s.planPricing },
                React.createElement(SolutionBadge, { t: function (k, o) { return props.t(k, o); }, isInstalled: isAppInstalled, showPremiumLabel: props.pricing &&
                        props.pricing.isRequiredWixPremium &&
                        !props.marketplaceStore.siteIsPremium, isBundleAppNotInstalled: isBundleAppAndNotInstalled(props.id, props.marketplaceStore.bundleApps), isBundleAppInstalled: isBundleAppAndInstalled(props.id, props.marketplaceStore.bundleApps), isAppSetupIncomplete: isAppSetupIncomplete((_a = props.marketplaceStore.installedApps) === null || _a === void 0 ? void 0 : _a.find(function (installedApp) {
                        return installedApp.webSolutionBase.id === props.id;
                    }), props.experiments), shouldShowIncompleteSetupPopover: true, savedPrice: getBundleAppSavedPrice(props.id, props.marketplaceStore.bundleApps), pricing: props.pricing, companyId: props.companyId })))));
});
export var onDeveloperNameClick = function (biData) {
    // tslint:disable-next-line: no-floating-promises
    biLogger.appModalDevNameLinkClick(biData.biData.devNameClickData); //if fales?
};
export var RateAndReviewers = composer()
    .withTranslation()
    .compose(function (props) {
    var goToReviewsSection = function (e) {
        e.preventDefault();
        var reviewsSection = document.getElementById('reviews');
        reviewsSection && reviewsSection.scrollIntoView();
    };
    var noReviews = props.reviewStars === 0;
    return (React.createElement("div", { className: s.userRankingContainer, property: "aggregateRating", typeof: "AggregateRating" },
        React.createElement(StarFilled, { className: noReviews ? s.rateStarGray : s.rateStar }),
        React.createElement("div", { className: s.oneStarRating },
            React.createElement(Text, { weight: noReviews ? 'thin' : 'bold', dataHook: "solution-review-test", className: s.reviewStar, property: "ratingValue" }, noReviews
                ? props.t('solution.page.details.review.empty')
                : Number(props.reviewStars).toFixed(1)),
            !noReviews && (React.createElement(Text, { dataHook: "solution-review-test" },
                React.createElement("a", { href: "#reviews", onClick: goToReviewsSection },
                    ' ',
                    "(",
                    React.createElement("span", { property: "ratingCount" }, props.numberOfReviews),
                    ")"))))));
});
export var dtoBaseToDeatilsBiData = function (baseInfo) {
    return {
        category: categoryFilter(baseInfo.Tags),
        devNameClickData: {
            app_id: baseInfo.id,
            market: config.originForBI,
            msid: '',
            origin: config.origin,
            vertical: 'solution-page',
        },
    };
};
export var categoryFilter = function (tags) {
    var filteredTags = tags && tags.filter(function (tag) { return !tag.parentSlug && tag.type === 'CATEGORY'; });
    var categoryName = (filteredTags && filteredTags.length > 0 && filteredTags[0].name) || '';
    return categoryName;
};
//# sourceMappingURL=solution-info-details.js.map